import { FC } from 'react';
import { Wrapper } from '../../hosting/EditButton/Wrapper';
import config from '../../../config';

type CmpProps = {
  rooomId: string;
};

const OpenWebinar: FC<CmpProps> = ({ rooomId }) => {
  const studioLink = `${config().urls.streamingStudio}${rooomId}`;

  return (
    <Wrapper
      href={studioLink}
      size="full-width"
      variant="light-blue"
      buttonType="container"
      icon="images/dashboard/edit_video_icon.svg"
    >
      Open Studio
    </Wrapper>
  );
};

export default OpenWebinar;
